import { render, staticRenderFns } from "./TextParagraph.vue?vue&type=template&id=c591259a&"
import script from "./TextParagraph.vue?vue&type=script&lang=js&"
export * from "./TextParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports